"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeHxRequestSearchSuggestionsArgs = void 0;
var HxTimeSpan_1 = require("./HxTimeSpan");
function serializeHxRequestSearchSuggestionsArgs(_arg) {
    var output = [];
    var accountIdsOutput = [];
    _arg.accountIds.forEach(function (item) { return accountIdsOutput.push(item.toString()); });
    output.push(accountIdsOutput);
    output.push(_arg.searchQuery);
    output.push(_arg.viewId.toString());
    output.push(_arg.type);
    output.push(_arg.enableTextDecorations);
    output.push(_arg.isMultiAccountRequest !== undefined);
    if (_arg.isMultiAccountRequest !== undefined) {
        output.push(_arg.isMultiAccountRequest);
    }
    output.push(_arg.logicalId);
    output.push(_arg.searchConversationIdFor3S);
    output.push(_arg.substrateScenarioName);
    output.push(_arg.substrateDebugSetting);
    output.push(_arg.substrateFlightsControlledByClient);
    output.push(_arg.requestIssuedTime.valueOf());
    output.push(_arg.allowOffline);
    output.push(_arg.timeoutToOfflineSearchFallback !== undefined);
    if (_arg.timeoutToOfflineSearchFallback !== undefined) {
        output.push(HxTimeSpan_1.serializeHxTimeSpan(_arg.timeoutToOfflineSearchFallback));
    }
    return output;
}
exports.serializeHxRequestSearchSuggestionsArgs = serializeHxRequestSearchSuggestionsArgs;
